module.exports = __webpack_public_path__ + "img/Steady.8ac6d0e8.svg";